import { createSelector } from 'reselect';
import { INITIAL_STATE } from './initialState';

export const selectNotification = (state) => state.notification;

export const selectNotifications = createSelector(
  selectNotification,
  (notification) => notification.notifications
);
